import {createContext} from 'react';

interface ServiceCaseDetailActionsContextType {
  executeAction: <T>(key: string, action: () => Promise<T>) => Promise<T>;
  isActionPending: (key: string) => boolean;
  isAnyActionPending: boolean;
  getPendingActions: () => string[];
}

export const ServiceCaseDetailActionsContext = createContext<
  ServiceCaseDetailActionsContextType | undefined
>(undefined);
